export default __webpack_public_path__ + "static/media/heart_off.a261d4cc.svg";